import React, { useState } from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon, CheckCircleIcon } from 'lucide-react';
const packs = [{
  id: 'avanzado',
  icon: '📦',
  label: 'OFERTA ACTIVA',
  labelColor: 'bg-brand-orange',
  title: 'SISTEMA INICIAL',
  subtitle: 'El Sistema Completo — 5 Tomos + 3 Bonos',
  details: ['Tomo 1: El Arquitecto Curricular', 'Tomo 2: El Creativo de Aula', 'Tomo 3: El Auditor de Notas', 'Tomo 4: El Escudo Administrativo', 'Tomo 5: El Facilitador de Inclusión', 'Los 3 Bonos Exclusivos', 'Actualizaciones de por vida'],
  originalPrice: '$57.700',
  price: '$19.990',
  href: 'https://checkout.guiadigital360.online/cart/44851194298437:1',
  borderSelected: 'border-brand-orange',
  ringSelected: 'ring-brand-orange',
  priceColor: 'text-brand-orange',
  savings: 'Ahorrás $37.710'
}, {
  id: 'vip',
  icon: '💎',
  label: 'RECOMENDADO',
  labelColor: 'bg-brand-blue',
  title: 'SISTEMA VIP',
  subtitle: 'Sistema Completo + Inteligencia Centralizada',
  details: ['Todo lo del Sistema Inicial', 'El Cerebro Digital Docente (60 módulos)', '50 Prompts VIP de Alta Ingeniería', '5 Flujos de Automatización en Cadena', 'Configuración del Mando Central', 'Entrenamiento de tu estilo docente'],
  originalPrice: '$78.700',
  price: '$26.990',
  href: 'https://checkout.guiadigital360.online/cart/44851198394437:1',
  borderSelected: 'border-brand-blue',
  ringSelected: 'ring-brand-blue',
  priceColor: 'text-brand-blue',
  savings: 'Ahorrás $51.710'
}];
export function PricingSection() {
  const [selected, setSelected] = useState<string>('avanzado');
  const selectedPack = packs.find(p => p.id === selected)!;
  const getButtonText = () => {
    if (selected === 'avanzado') return '👉 QUIERO EL SISTEMA INICIAL →';
    return '👉 QUIERO EL SISTEMA VIP →';
  };
  const getButtonClass = () => {
    if (selected === 'vip') {
      return 'bg-brand-blue hover:bg-blue-700 shadow-[0_8px_25px_-5px_rgba(0,87,217,0.5)] hover:shadow-[0_12px_30px_-5px_rgba(0,87,217,0.7)]';
    }
    return '';
  };
  return <section id="compra" className="py-10 md:py-20 px-4 bg-brand-dark scroll-mt-10" data-id="element-199">
      <div className="max-w-2xl mx-auto" data-id="element-200">
        <div className="text-center mb-5 md:mb-8" data-id="element-201">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-2 md:mb-3" data-id="element-202">
            Elegí tu Sistema:
          </h2>
          <p className="text-xl md:text-2xl font-bold text-brand-blue" data-id="element-203">
            Precios de Lanzamiento
          </p>
        </div>

        {/* Selectable Cards */}
        <div className="space-y-3 md:space-y-4 mb-6 md:mb-8" data-id="element-204">
          {packs.map(pack => {
          const isSelected = selected === pack.id;
          return <button key={pack.id} onClick={() => setSelected(pack.id)} className={`w-full text-left rounded-2xl p-4 md:p-6 transition-all duration-200 relative
                  ${isSelected ? `bg-white/10 shadow-xl border-3 ${pack.borderSelected} ring-2 ${pack.ringSelected}` : 'bg-white/5 shadow-sm border-2 border-white/10 opacity-75 hover:opacity-100 hover:shadow-md'}`} data-id="element-205">
                {/* Badge */}
                {pack.label && <div className={`absolute -top-3 left-4 ${pack.labelColor} text-white font-black px-3 py-0.5 rounded-full text-[10px] md:text-xs tracking-wider shadow-md`} data-id="element-206">
                    ⭐ {pack.label}
                  </div>}

                <div className="flex items-start gap-3 md:gap-4" data-id="element-207">
                  {/* Radio indicator */}
                  <div className="mt-1 flex-shrink-0" data-id="element-208">
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? pack.id === 'avanzado' ? 'border-brand-orange bg-brand-orange' : pack.id === 'primaria' ? 'border-purple-600 bg-purple-600' : 'border-brand-blue bg-brand-blue' : 'border-gray-300 bg-white'}`} data-id="element-209">
                      {isSelected && <CheckCircleIcon className="w-5 h-5 text-white" data-id="element-210" />}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-grow min-w-0" data-id="element-211">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-1 md:gap-4 mb-2" data-id="element-212">
                      <h3 className="text-lg md:text-xl font-black text-white flex items-center gap-2" data-id="element-213">
                        <span data-id="element-214">{pack.icon}</span> {pack.title}
                      </h3>
                      <div className="flex items-center gap-2" data-id="element-215">
                        {pack.originalPrice && <span className="text-gray-400 text-sm line-through font-bold" data-id="element-216">
                            {pack.originalPrice}
                          </span>}
                        <span className={`text-2xl md:text-3xl font-black ${pack.priceColor}`} data-id="element-217">
                          {pack.price}
                        </span>
                        <span className="text-xs text-gray-500 font-medium" data-id="element-218">
                          ARS
                        </span>
                      </div>
                    </div>

                    <p className="text-sm text-gray-400 font-medium mb-2" data-id="element-219">
                      {pack.subtitle}
                    </p>

                    {isSelected && <div className="mt-3 space-y-2" data-id="element-220">
                        {pack.details.map((d, i) => <p key={i} className="text-xs md:text-sm text-gray-300 flex items-start gap-2 leading-relaxed" data-id="element-221">
                            <span className="text-brand-green flex-shrink-0 mt-0.5" data-id="element-222">
                              ✅
                            </span>{' '}
                            <span data-id="element-223">{d}</span>
                          </p>)}
                        {pack.savings && <div className="bg-green-100 text-green-800 font-bold text-center py-1.5 rounded-lg text-sm mt-3" data-id="element-224">
                            {pack.savings}
                          </div>}
                      </div>}
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* Single CTA Button */}
        <div className="mb-8" data-id="element-225">
          <CTAButton text={getButtonText()} href={selectedPack.href} isLink={true} className={getButtonClass()} data-id="element-226" />
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-xs md:text-sm text-gray-600 font-bold bg-white py-4 px-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-227">
          <span className="flex items-center gap-1.5" data-id="element-228">
            <LockIcon className="w-4 h-4 md:w-5 md:h-5 text-gray-500" data-id="element-229" /> Pago
            seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-230">
            <ZapIcon className="w-4 h-4 md:w-5 md:h-5 text-yellow-500" data-id="element-231" /> Acceso
            en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-232">
            <ShieldCheckIcon className="w-4 h-4 md:w-5 md:h-5 text-brand-green" data-id="element-233" />{' '}
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-234">
            <CreditCardIcon className="w-4 h-4 md:w-5 md:h-5 text-blue-500" data-id="element-235" />{' '}
            Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}